import {getScrollbarWidth} from '../util/helperFunctions';

window.addEventListener('load', () => {
	if (document.querySelectorAll('.video-box [data-bs-toggle="modal"]')) {
		const scrollbarWidth = getScrollbarWidth();
		const siteHeader = document.getElementById('site-header');
		const adminbar = document.getElementById('wpadminbar');
		const modals = document.querySelectorAll('.modal-video-box');

		modals.forEach(function (modalEl) {
			const modal = modalEl;
			const modalVideo = modal.querySelector('video');

			modal.addEventListener('show.bs.modal', () => {
				if (siteHeader) {
					siteHeader.style.right = scrollbarWidth + 'px';
				}

				if (adminbar) {
					adminbar.style.right = scrollbarWidth + 'px';
					adminbar.style.width = 'auto';
				}

				const isVideoPlaying = () =>
					!!(
						modalVideo &&
						modalVideo.currentTime > 0 &&
						!modalVideo.paused &&
						!modalVideo.ended &&
						modalVideo.readyState > 2
					);

				if (modalVideo && modalVideo.ended) {
					modalVideo.currentTime = 0;
				}

				if (!isVideoPlaying() && !modalVideo.classList.contains('lazy')) {
					modalVideo.play();
				}
			});

			modal.addEventListener('hidden.bs.modal', () => {
				modalVideo.pause();

				if (siteHeader) {
					siteHeader.style.right = '';
				}

				if (adminbar) {
					adminbar.style.right = '';
					adminbar.style.width = '';
				}
			});
		});
	}

	// Lazy video - after user action
	const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));
	let isVideosObserverRunning = false;

	if ('IntersectionObserver' in window && !isVideosObserverRunning) {
		// Add event listeners to trigger intersection checks
		window.addEventListener('touchstart', () => tpslVideos());
		window.addEventListener('scroll', () => tpslVideos());
		window.addEventListener('wheel', () => tpslVideos());

		const tpslVideos = () => {
			if (isVideosObserverRunning) {
				return;
			}

			isVideosObserverRunning = true;

			// eslint-disable-next-line no-undef
			const lazyVideoObserver = new IntersectionObserver(function (entries) {
				entries.forEach(function (video) {
					if (video.isIntersecting) {
						for (const source in video.target.children) {
							const videoSource = video.target.children[source];
							if (
								typeof videoSource.tagName === 'string' &&
								videoSource.tagName === 'SOURCE'
							) {
								videoSource.src = videoSource.dataset.src;
							}
						}

						video.target.load();
						video.target.classList.remove('lazy');
						lazyVideoObserver.unobserve(video.target);

						const isVideoPlaying = () =>
							!!(
								video.target &&
								video.target.currentTime > 0 &&
								!video.target.paused &&
								!video.target.ended &&
								video.target.readyState > 2
							);
						if (!isVideoPlaying()) {
							video.target.play();
						}
					}
				});
			});

			lazyVideos.forEach(function (lazyVideo) {
				lazyVideoObserver.observe(lazyVideo);
			});
		};
	}
});
